import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useTheme } from '../../contexts/ThemeContext';
import { Sun, Moon, Menu as MenuIcon, ArrowLeft, LogOut, Timer } from 'lucide-react';
// Importação do Botão PWA
import PWAInstallPrompt from '../shared/PWAInstallPrompt';

const Header = ({ toggleSidebar }) => {
  const { user, logout, sessionTimeLeft } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };
  
  const handleGoBack = () => {
    window.history.back();
  };

  const formatTime = (ms) => {
    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  // ⚡ ESTILO MÁGICO PARA IOS ⚡
  // Remove o delay de clique, remove o highlight cinza e melhora a resposta
  const touchStyle = {
    WebkitTapHighlightColor: 'transparent',
    touchAction: 'manipulation',
    cursor: 'pointer'
  };

  return (
    <header className="flex items-center justify-between px-4 sm:px-6 h-16 bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800 shadow-sm z-20 flex-shrink-0 relative">
        
        <div className="flex items-center gap-3">
            {/* Botão Menu Mobile */}
            <button 
                onClick={toggleSidebar} 
                className="lg:hidden p-3 -ml-3 rounded-lg text-gray-600 dark:text-gray-300 active:bg-gray-200 dark:active:bg-gray-700 transition-colors touch-manipulation"
                aria-label="Abrir menu"
                style={touchStyle}
            >
                <MenuIcon size={24} />
            </button>

            <div className="flex items-center space-x-2">
                <button
                    onClick={handleGoBack}
                    className="hidden lg:flex items-center justify-center w-9 h-9 rounded-full text-gray-500 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800 transition-colors"
                    title="Voltar"
                    style={touchStyle}
                >
                    <ArrowLeft size={20} />
                </button>
                
                <Link to="/dashboard" className="hidden lg:block" style={touchStyle}>
                    <h1 className="text-xl font-bold text-gray-900 dark:text-white ml-2">Portal do <span className="text-blue-600 dark:text-blue-400 text-sm font-medium uppercase ml-1">Servidor</span></h1>
                </Link>

                <div className="flex items-center gap-2 lg:hidden">
                    <div className="bg-blue-600 text-white p-1 rounded font-bold text-xs shadow-sm">PS</div>
                    <h1 className="text-lg font-bold text-gray-900 dark:text-white tracking-tight">Portal</h1>
                </div>
            </div>
        </div>

        <div className="flex items-center space-x-2 md:space-x-4">
            
            {/* 🔹 BOTÃO DE INSTALAÇÃO PWA 🔹 */}
            <div style={touchStyle}>
                <PWAInstallPrompt className="mr-1 active:scale-95 transition-transform" />
            </div>

            <div className="hidden sm:flex items-center text-orange-600 bg-orange-100 dark:text-orange-300 dark:bg-orange-900/50 px-3 py-1 rounded-full border border-orange-200 dark:border-orange-800/50">
              <Timer size={14} className="mr-2" />
              <span className="font-mono text-xs font-bold">
                {formatTime(sessionTimeLeft)}
              </span>
            </div>

            <div className="text-right hidden xl:block mr-2">
                <p className="text-xs text-gray-500 dark:text-gray-400">Logado como</p>
                <p className="text-sm font-bold text-gray-700 dark:text-gray-200 truncate max-w-[150px]">{user?.name?.split(" ")[0]}</p>
            </div>

            {/* Botão Tema - Otimizado para iOS */}
            <button 
                onClick={toggleTheme} 
                className="flex items-center justify-center w-9 h-9 rounded-full text-gray-500 hover:bg-gray-100 active:bg-gray-200 dark:text-gray-400 dark:hover:bg-gray-800 dark:active:bg-gray-700 transition-colors" 
                title="Alternar Tema"
                style={touchStyle}
            >
                {theme === 'light' ? <Moon size={18} /> : <Sun size={18} />}
            </button>
            
            {/* Botão Logout - Otimizado para iOS */}
            <button 
                onClick={handleLogout} 
                className="hidden lg:flex items-center justify-center w-9 h-9 rounded-full text-red-500 hover:bg-red-50 active:bg-red-100 dark:hover:bg-red-900/20 transition-colors" 
                title="Sair"
                style={touchStyle}
            >
                <LogOut size={18} />
            </button>
        </div>
    </header>
  );
};

export default Header;